<template>
  <div class="consultation-container">
    <div class="consultation-title">数字化转型全案咨询</div>
    <div class="consultation-main">
      <div class="consultation-item" v-for="item in consultationList" :key="item.id">
        <div class="consultation-item-ing">
          <imgContainer :src="item.caseCover" />
        </div>
        <div class="consultation-item-name" :title="item.caseName">{{handleChara(item.caseName,40)}}</div>
        <div class="consultation-item-txt" :title="item.caseIntroduction">{{handleChara(item.caseIntroduction,95)}}</div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {getConsultationList} from "@/api/apiHome";
import {ref} from "vue";
import {handleChara} from "@/utils/title";
import imgContainer from '@/components/imgContainer/index.vue'

const consultationList=ref([])
const queryConsultationList = async () => {
  const {code, data} = await getConsultationList();
  if (code === 200) {
    consultationList.value = data?.length>4 ? data.slice(0,4) : data;
  }
}
queryConsultationList()
</script>

<style scoped lang="scss">
.consultation-container {
  padding: 50px 0;
  box-sizing: border-box;
  background: #F4F8FF;
}

.consultation-title {
  font-weight: bold;
  font-size: 28px;
  color: #242424;
  margin-bottom: 40px;
  position: relative;
  text-align: center;
}

.consultation-title::after {
  content: "";
  position: absolute;
  bottom: -16px;
  left: 50%;
  transform: translateX(-50%);
  width: 52px;
  height: 4px;
  background: #0048A9;
  border-radius: 2px;
  transition: all 0.3s ease;
}

.consultation-main {
  width: 1200px;
  margin: 0 auto;
  padding: 30px 0;
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  gap: 30px;
}
.consultation-item{
  width: 585px;
  padding: 15px;
  box-sizing: border-box;
  background: #ffffff;
  .consultation-item-ing{
    width: 554px;
    height: 315px;
    object-fit: cover;
  }
  .consultation-item-name{
    font-weight: bold;
    font-size: 20px;
    color: #242424;
    margin: 22px 0 17px 0;
  }
  .consultation-item-txt{
    font-size: 18px;
    color: #797979;
  }
}
</style>

